import {
    getToken,
    getUser,
} from "../../Utils/Common";
import Moment from "moment";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

export const getAttendance = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/get_attendance",
            {
                requester: getUser(),
                token: getToken(),
                attendance_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getAllAttendance = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/get_all_attendance",
            {
                requester: getUser(),
                token: getToken(),
                branch_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const searchAttendance = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/search",
            {
                requester: getUser(),
                token: getToken(),
                branch_id: data.branch_id,
                employee_id: data.employee_id,
                group_datetime: data.group_datetime,
                branch_name: data.branch_name,
                employee_name: data.employee_name,
                by_employees: data.by_employees,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
                date: data.date ? Moment(data.date).format("YYYY-MM-DD") : "",
                group_branch: data.group_branch,
                page: data.page
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const searchAttendancePage = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/get_attendance_per_employee",
            {
                requester: getUser(),
                token: getToken(),
                employee_id: data.employee_id,
                employee_name: data.employee_name,
                date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : "",
                date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : "",
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const addOvertime = async (info) => {
    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "attendances/update_overtime",
            {
                requester: getUser(),
                token: getToken(),
                // employee_id: info.employee_id,
                attendance_id: info.id,
                overtime: info.ot_hours,
                approved_by: info.added_by_id,
                overtime_remarks: info.remarks,
            }
        );
        //
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const deleteAttendance = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "attendances/delete",
            {
                requester: getUser(),
                token: getToken(),
                attendance_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};